import { TOptionOf } from 'root-types'

export const FEEL_BETTER_ABOUT_TYPE = {
  ENERGY: 'energy',
  SLEEP: 'sleep',
  STRESS: 'stress',
  SKIN_AND_HAIR: 'skin_and_hair',
  WOMENS_HEALTH: 'womens_health',
  MENS_HEALTH: 'mens_health',
  JOINT_AND_MUSCLE: 'joint_and_muscle',
} as const

export const WOMEN_FEEL_BETTER_ABOUT_OPTIONS = [
  {
    value: FEEL_BETTER_ABOUT_TYPE.ENERGY,
    text: 'onboarding.feelBetterAbout.energy',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SLEEP,
    text: 'onboarding.feelBetterAbout.sleep',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.STRESS,
    text: 'onboarding.feelBetterAbout.stress',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SKIN_AND_HAIR,
    text: 'onboarding.feelBetterAbout.skinAndHair',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.WOMENS_HEALTH,
    text: 'onboarding.feelBetterAbout.womensHealth',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.JOINT_AND_MUSCLE,
    text: 'onboarding.feelBetterAbout.jointAndMuscle',
  },
] as const satisfies readonly TOptionOf<typeof FEEL_BETTER_ABOUT_TYPE>[]

export const MEN_FEEL_BETTER_ABOUT_OPTIONS = [
  {
    value: FEEL_BETTER_ABOUT_TYPE.ENERGY,
    text: 'onboarding.feelBetterAbout.energy',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SLEEP,
    text: 'onboarding.feelBetterAbout.sleep',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.STRESS,
    text: 'onboarding.feelBetterAbout.stress',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.SKIN_AND_HAIR,
    text: 'onboarding.feelBetterAbout.skinAndHair',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.MENS_HEALTH,
    text: 'onboarding.feelBetterAbout.mensHealth',
  },
  {
    value: FEEL_BETTER_ABOUT_TYPE.JOINT_AND_MUSCLE,
    text: 'onboarding.feelBetterAbout.jointAndMuscle',
  },
] as const satisfies readonly TOptionOf<typeof FEEL_BETTER_ABOUT_TYPE>[]
